import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

import Button from '@/components/Button';

function ErrorBoundary() {
	const error = useRouteError();
	const { t } = useTranslation();

	return (
		<div className="flex h-[100vh] flex-col items-center justify-center gap-3">
			<h2 className="text-lg font-bold">{t('errors.generic')}</h2>
			{import.meta.env.DEV && <p>{error?.message}</p>}
			<Button className="mt-2" onClick={() => window.location.reload(true)}>
				{t('common.refresh')}
			</Button>
		</div>
	);
}

export default ErrorBoundary;
